import { MutationResult } from "@/api/utils/types"
import { useMutation } from "@/api/utils/useQuery"
import { formatDateDashed } from "@/helpers/dateHelper"
import { AuthService } from "@/services/AuthService"
import {
  IDebtPaymentPlanCancel,
  IDebtPaymentPlanCreate,
} from "./DebtPaymentPlanMutator.types"
import {
  BackofficeRestMutations,
  CancelPaymentPlanPayload,
  CreatePaymentPlanPayload,
} from "@/api/backofficeRest/mutations"
import { AccountPaymentPlan } from "@/api/backofficeRest/generated/model"

export interface IDebtPaymentPlanMutator {
  createForAccount(
    juniferAccountId: number,
  ): MutationResult<IDebtPaymentPlanCreate, AccountPaymentPlan>
  cancelForAccount(
    juniferAccountId: number,
    type: string,
  ): MutationResult<IDebtPaymentPlanCancel, void>
}

class DebtPaymentPlanMutatorClass implements IDebtPaymentPlanMutator {
  createForAccount(juniferAccountId: number) {
    return useMutation({
      ...BackofficeRestMutations.paymentPlans.create(),
      invalidateCache: false,
      serializerFn: (
        data: IDebtPaymentPlanCreate,
      ): CreatePaymentPlanPayload => {
        return {
          accountId: juniferAccountId,
          body: {
            billingAccountId: data.billingAccountId,
            userName: AuthService.getCurrentUser().username,
            debtPlanLengthInMonths: data.debtPlanLengthInMonths,
            ...(data.debtPlanFirstPaymentDate && {
              debtPlanFirstPaymentDate: formatDateDashed(
                data.debtPlanFirstPaymentDate,
              ),
            }),
          },
        }
      },
    })
  }
  cancelForAccount(juniferAccountId: number, type: string) {
    return useMutation({
      ...BackofficeRestMutations.paymentPlans.cancel(),
      invalidateCache: false,
      serializerFn: (
        data: IDebtPaymentPlanCancel,
      ): CancelPaymentPlanPayload => {
        return {
          accountId: juniferAccountId,
          body: {
            paymentPlanId: data.paymentPlanId,
            userName: AuthService.getCurrentUser().username,
            ignoreWarnings: true,
          },
          params: { type },
        }
      },
    })
  }
}

export const DebtPaymentPlanMutator = new DebtPaymentPlanMutatorClass()
